(function () {
  'use strict';

  var PROXY_URL = '/apps/paymentstatussync/delivery/warehouse-inventory';
  var POLL_MS = 90000;
  var LEGACY_TEXT_MARKERS = ['How many you have', 'How many you have?', 'Inventory Info'];
  var STYLE_ID = 'bmw-warehouse-inventory-css';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var R = '[data-product-warehouse-inventory]';
    var css = [
      /* Container */
      R + '{--bi-ink:var(--toee-ink);--bi-body:var(--toee-text);--bi-muted:var(--toee-muted);--bi-primary:var(--toee-blue);--bi-primary-bg:var(--toee-surface-soft);--bi-error:var(--toee-status-error);--bi-error-bg:var(--toee-surface-soft);--bi-line:var(--toee-border);--bi-canvas:var(--toee-surface);--bi-surf:var(--toee-surface-soft);',
        'background:var(--bi-canvas);border:1px solid var(--bi-line);border-left:3px solid var(--bi-primary);',
        'border-radius:0;padding:18px 22px 16px;margin:16px 0;color:var(--bi-ink);box-shadow:none;contain:layout style}',
      /* Head */
      R + ' .bmw-inventory__head{padding-bottom:12px;margin-bottom:4px;border-bottom:1px solid var(--bi-line)}',
      R + ' .bmw-inventory__title{margin:0;font-size:var(--toee-text-sm);font-weight:700;line-height:1.3;letter-spacing:1px;text-transform:uppercase;color:var(--bi-muted)}',
      /* List — forcibly reset theme list styles */
      R + ' .bmw-inventory__list{list-style:none!important;margin:0!important;padding:0!important;display:flex!important;flex-direction:column!important}',
      /* Row */
      R + ' .bmw-inventory__row{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:12px!important;padding:11px 0!important;border-bottom:1px solid var(--bi-line)!important;list-style:none!important}',
      R + ' .bmw-inventory__row:last-child{border-bottom:none!important;padding-bottom:2px!important}',
      /* Name */
      R + ' .bmw-inventory__name{font-size:var(--toee-text-md)!important;font-weight:400!important;line-height:1.4!important;color:var(--bi-body)!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      /* Status wrapper */
      R + ' .bmw-inventory__status{display:inline-flex!important;align-items:center!important;justify-content:flex-end!important}',
      /* Badge */
      R + ' .bmw-inventory__badge{display:inline-flex!important;align-items:center!important;padding:3px 9px!important;font-size:var(--toee-text-sm)!important;font-weight:700!important;line-height:1.5!important;border-radius:0!important;white-space:nowrap!important;font-variant-numeric:tabular-nums}',
      R + ' .bmw-inventory__badge--capped{background:var(--bi-primary-bg)!important;color:var(--bi-primary)!important}',
      R + ' .bmw-inventory__badge--exact{background:var(--bi-error-bg)!important;color:var(--bi-error)!important}',
      R + ' .bmw-inventory__badge--zero{background:#f4f4f4!important;color:#9a9a9a!important}',
      /* Skeleton */
      R + ' .bmw-inventory__skel{display:inline-block!important;height:12px!important;border-radius:0!important;background:linear-gradient(90deg,var(--bi-surf) 0%,var(--bi-line) 50%,var(--bi-surf) 100%)!important;background-size:220% 100%!important;animation:bi-shimmer 1.4s ease-in-out infinite!important}',
      R + ' .bmw-inventory__skel--name{width:130px!important}',
      R + ' .bmw-inventory__skel--badge{width:80px!important;height:22px!important}',
      /* Message */
      R + ' .bmw-inventory__message{margin:10px 0 0!important;padding:10px 0 0!important;border-top:1px solid var(--bi-line)!important;font-size:var(--toee-text-md)!important;font-weight:300!important;line-height:1.45!important;color:var(--bi-muted)!important}',
      R + ' .bmw-inventory__message.hidden{display:none!important}',
      /* Visually hidden */
      '.bmw-inv-sr{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}',
      /* Shimmer keyframe */
      '@keyframes bi-shimmer{0%{background-position:120% 0}100%{background-position:-120% 0}}',
      /* Reduced motion */
      '@media(prefers-reduced-motion:reduce){' + R + ' .bmw-inventory__skel{animation:none!important}}',
      /* Mobile */
      '@media(max-width:768px){' + R + '{padding:14px 16px 12px!important;margin:12px 0!important}',
        R + ' .bmw-inventory__row{padding:10px 0!important}}',
      /* Suppress legacy HulkApps */
      '[data-pdp-suppress-legacy-inventory] [class^="inventoryInfo"],[data-pdp-suppress-legacy-inventory] [class*=" inventoryInfo"],',
      '[data-pdp-suppress-legacy-inventory] [id^="inventoryInfo"],[data-pdp-suppress-legacy-inventory] [id^="inventory_info"],',
      '[data-pdp-suppress-legacy-inventory] [id^="inventory-info"],[data-pdp-suppress-legacy-inventory] [class*="hulkapps_inv"],',
      '[data-pdp-suppress-legacy-inventory] [class*="hulkapps-inv"],[data-pdp-suppress-legacy-inventory] [data-pdp-legacy-inventory-suppressed]',
      '{display:none!important;visibility:hidden!important}',
      '[data-pdp-suppress-legacy-inventory] [data-pdp-legacy-inventory-suppressed]:has(.purchase-section),',
      '[data-pdp-suppress-legacy-inventory] [data-pdp-legacy-inventory-suppressed]:has(.add-to-cart),',
      '[data-pdp-suppress-legacy-inventory] [data-pdp-legacy-inventory-suppressed]:has([data-atc])',
      '{display:revert!important;visibility:visible!important}'
    ].join('');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    (document.head || document.documentElement).appendChild(el);
  }

  function WarehouseInventory(el) {
    this.el = el;
    this.variantId = el.getAttribute('data-variant-id');
    this.list = el.querySelector('[data-product-warehouse-inventory-list]');
    this.message = el.querySelector('[data-product-warehouse-inventory-message]');
    this.pollTimer = null;
    this.requestId = 0;
    this._lastGoodInventory = null;
    this._bound = {
      onVariantChange: this._onVariantChange.bind(this),
      onVisibilityChange: this._onVisibilityChange.bind(this),
      suppressLegacy: this._suppressLegacy.bind(this)
    };
    this._suppressTimer = null;
    this._legacyObserver = null;
    this._init();
  }

  WarehouseInventory.prototype._init = function () {
    injectStyles();
    window.addEventListener('product-variant-switch', this._bound.onVariantChange);
    document.addEventListener('variant:changed', this._bound.onVariantChange);
    document.addEventListener('variantChanged', this._bound.onVariantChange);
    document.addEventListener('variant-change', this._bound.onVariantChange);
    document.addEventListener('visibilitychange', this._bound.onVisibilityChange);
    this._showLoading();
    this._fetch();
    this._schedulePoll();
    this._startLegacySuppression();
  };

  WarehouseInventory.prototype._onVariantChange = function (event) {
    var detail = event && event.detail ? event.detail : {};
    var variant = detail.variant || {};
    var variantId = detail.variantId || variant.id;
    if (!variantId) return;
    variantId = String(variantId);
    if (variantId === this.variantId) return;
    this.variantId = variantId;
    this.el.setAttribute('data-variant-id', variantId);
    this._lastGoodInventory = null;
    this._showLoading();
    this._clearPoll();
    this._fetch();
    this._schedulePoll();
  };

  WarehouseInventory.prototype._onVisibilityChange = function () {
    if (document.hidden) {
      this._clearPoll();
      return;
    }
    this._fetch();
    this._schedulePoll();
  };

  WarehouseInventory.prototype._schedulePoll = function () {
    var self = this;
    this._clearPoll();
    this.pollTimer = setInterval(function () {
      if (!document.hidden) self._fetch();
    }, POLL_MS);
  };

  WarehouseInventory.prototype._clearPoll = function () {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  };

  WarehouseInventory.prototype._fetch = function () {
    if (typeof window === 'undefined' || !this.variantId) return;
    var self = this;
    var requestId = ++this.requestId;
    var variantId = String(this.variantId);
    var url = PROXY_URL + '?variant_id=' + encodeURIComponent(variantId);

    fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json().catch(function () { return null; }).then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        if (requestId !== self.requestId) return;
        if (!result.ok || !result.body || result.body.success === false) {
          self._handleFetchFailure(result);
          return;
        }
        var inventory = result.body.productWarehouseInventory;
        if (!inventory || String(inventory.variantId) !== variantId) {
          self._handleFetchFailure({ ok: false, body: null });
          return;
        }
        self._lastGoodInventory = inventory;
        self._render(inventory);
      })
      .catch(function () {
        if (requestId !== self.requestId) return;
        self._handleFetchFailure(null);
      });
  };

  WarehouseInventory.prototype._text = function (name, fallback) {
    return this.el.getAttribute('data-i18n-' + name) || fallback;
  };

  WarehouseInventory.prototype._showLoading = function () {
    if (this.message) {
      this.message.classList.add('hidden');
      this.message.textContent = '';
    }
    if (!this.list) return;
    var loadingText = this._text('loading', 'Checking warehouse inventory...');
    var fragment = document.createDocumentFragment();
    for (var i = 0; i < 3; i++) {
      fragment.appendChild(this._buildLoadingRow(i === 0 ? loadingText : null));
    }
    this.list.replaceChildren(fragment);
  };

  WarehouseInventory.prototype._buildLoadingRow = function (announceText) {
    var row = document.createElement('li');
    var warehouse = document.createElement('span');
    var dot = document.createElement('span');
    var nameSkel = document.createElement('span');
    var status = document.createElement('span');
    var statusSkel = document.createElement('span');

    row.className = 'bmw-inventory__row bmw-inventory__row--loading';
    if (announceText) {
      row.setAttribute('data-product-warehouse-inventory-loading', '');
    } else {
      row.setAttribute('aria-hidden', 'true');
    }

    warehouse.className = 'bmw-inventory__warehouse';
    dot.className = 'bmw-inventory__dot bmw-inventory__dot--idle';
    dot.setAttribute('aria-hidden', 'true');
    nameSkel.className = 'bmw-inventory__skel bmw-inventory__skel--name';
    nameSkel.setAttribute('aria-hidden', 'true');
    warehouse.appendChild(dot);
    warehouse.appendChild(nameSkel);

    status.className = 'bmw-inventory__status';
    statusSkel.className = 'bmw-inventory__skel bmw-inventory__skel--status';
    statusSkel.setAttribute('aria-hidden', 'true');
    status.appendChild(statusSkel);

    if (announceText) {
      var sr = document.createElement('span');
      sr.className = 'bmw-inv-sr';
      sr.textContent = announceText;
      status.appendChild(sr);
    }

    row.appendChild(warehouse);
    row.appendChild(status);
    return row;
  };

  WarehouseInventory.prototype._showMessage = function (text) {
    if (this.list) this.list.replaceChildren();
    if (!this.message) return;
    this.message.textContent = text;
    this.message.classList.remove('hidden');
  };

  WarehouseInventory.prototype._getFallbackLabels = function () {
    var raw = this.el.getAttribute('data-fallback-warehouses') || '';
    return raw.split(/[|\n]/).map(function (l) { return l.trim(); }).filter(Boolean);
  };

  WarehouseInventory.prototype._handleFetchFailure = function (result) {
    if (this._lastGoodInventory) {
      this._render(this._lastGoodInventory);
      return;
    }
    var fallback = this._getFallbackLabels();
    if (fallback.length > 0) {
      var rows = [];
      for (var i = 0; i < fallback.length; i++) {
        rows.push({
          warehouseLabel: fallback[i],
          warehouseKey: fallback[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
          displayMode: 'zero',
          quantity: 0,
          displayLine: ''
        });
      }
      this._render({
        variantAvailable: true,
        warehouses: rows,
        summary: { anyWarehouseAvailable: true }
      });
      return;
    }
    this._showMessage(this._text('error', 'Inventory temporarily unavailable'));
  };

  WarehouseInventory.prototype._render = function (inventory) {
    var apiRows = Array.isArray(inventory.warehouses) ? inventory.warehouses : [];
    var fallback = this._getFallbackLabels();

    // Build an index of API rows by label (lowercased)
    var apiByLabel = {};
    for (var i = 0; i < apiRows.length; i++) {
      var key = (apiRows[i].warehouseLabel || '').toLowerCase().trim();
      if (key) apiByLabel[key] = apiRows[i];
    }

    var allRows = [];

    if (fallback.length > 0) {
      // Use fallback list as the authoritative order; merge API data in
      for (var f = 0; f < fallback.length; f++) {
        var label = fallback[f];
        var lc = label.toLowerCase();
        if (apiByLabel[lc]) {
          allRows.push(apiByLabel[lc]);
          delete apiByLabel[lc];
        } else {
          // Warehouse not returned by API → qty = 0
          allRows.push({
            warehouseLabel: label,
            warehouseKey: label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
            displayMode: 'zero',
            quantity: 0,
            displayLine: ''
          });
        }
      }
      // Append any API rows not in fallback (unexpected warehouses)
      for (var extra in apiByLabel) {
        if (Object.prototype.hasOwnProperty.call(apiByLabel, extra)) {
          allRows.push(apiByLabel[extra]);
        }
      }
    } else {
      // No fallback configured — use raw API rows
      allRows = apiRows;
    }

    // If truly nothing to show and variant unavailable, show message
    if (allRows.length === 0) {
      this._showMessage(this._text('unavailable', 'Currently unavailable'));
      return;
    }

    if (this.message) {
      this.message.classList.add('hidden');
      this.message.textContent = '';
    }
    if (!this.list) return;

    var fragment = document.createDocumentFragment();
    for (var r = 0; r < allRows.length; r++) {
      fragment.appendChild(this._buildRow(allRows[r]));
    }
    this.list.replaceChildren(fragment);
  };

  WarehouseInventory.prototype._stripWarehousePrefix = function (label, displayLine) {
    if (!label || !displayLine) return displayLine || '';
    var stripped = displayLine;
    // Try "Label has " → "Label:" → "Label " → "Label" (no space, backend omits separator)
    var prefixes = [label + ' has ', label + ': ', label + ' ', label];
    for (var p = 0; p < prefixes.length; p++) {
      if (stripped.indexOf(prefixes[p]) === 0) {
        stripped = stripped.slice(prefixes[p].length);
        break;
      }
    }
    // Strip any residual leading "Warehouse" keyword the backend may have embedded
    stripped = stripped.replace(/^Warehouse[\s:]*/i, '');
    stripped = stripped.replace(/^\s+/, '').replace(/\s+$/, '');
    // Capitalize first character
    if (stripped.length > 0) {
      stripped = stripped.charAt(0).toUpperCase() + stripped.slice(1);
    }
    return stripped || displayLine;
  };

  WarehouseInventory.prototype._buildRow = function (rowData) {
    var row = document.createElement('li');
    var nameSpan = document.createElement('span');
    var status = document.createElement('span');
    var badge = document.createElement('span');

    var label = rowData.warehouseLabel || '';
    var rawMode = rowData.displayMode;
    var qty = rowData.quantity;

    // Determine effective display mode
    // Treat API exact with qty=0 same as our synthetic 'zero' rows
    var mode;
    if (rawMode === 'zero' || (rawMode === 'exact' && qty === 0)) {
      mode = 'zero';
    } else if (rawMode === 'exact') {
      mode = 'exact';
    } else {
      mode = 'capped';
    }

    // Determine status badge text
    var statusText;
    if (mode === 'zero') {
      statusText = '0 pcs';
    } else {
      var displayLine = rowData.displayLine || label;
      statusText = this._stripWarehousePrefix(label, displayLine);
      if (!statusText) statusText = displayLine;
    }

    row.className = 'bmw-inventory__row';
    if (rowData.warehouseKey) row.dataset.warehouseKey = rowData.warehouseKey;
    row.dataset.displayMode = mode;
    if (qty != null) row.dataset.quantity = String(qty);

    nameSpan.className = 'bmw-inventory__name';
    nameSpan.textContent = label;

    badge.className = 'bmw-inventory__badge bmw-inventory__badge--' + mode;
    badge.textContent = statusText;
    badge.setAttribute('aria-hidden', 'true');

    status.className = 'bmw-inventory__status';
    status.appendChild(badge);

    var srText = mode === 'zero' ? (label + ' has 0 pcs') : (rowData.displayLine || label);
    var sr = document.createElement('span');
    sr.className = 'bmw-inv-sr';
    sr.textContent = srText;
    status.appendChild(sr);

    row.appendChild(nameSpan);
    row.appendChild(status);
    return row;
  };

  WarehouseInventory.prototype._startLegacySuppression = function () {
    document.documentElement.setAttribute('data-pdp-suppress-legacy-inventory', '');
    var self = this;
    var run = function () { self._suppressLegacy(); };
    run();
    if (typeof MutationObserver === 'function') {
      this._legacyObserver = new MutationObserver(run);
      this._legacyObserver.observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    }
    if (this._suppressTimer) clearTimeout(this._suppressTimer);
    this._suppressTimer = setTimeout(run, 1500);
    setTimeout(run, 4000);
  };

  WarehouseInventory.prototype._isCommerceShell = function (node) {
    if (!node || !node.querySelector) return false;
    return !!(
      node.querySelector('.purchase-section') ||
      node.querySelector('.add-to-cart') ||
      node.querySelector('[data-atc]') ||
      node.querySelector('button[name="add"]') ||
      node.querySelector('.shopify-payment-button')
    );
  };

  WarehouseInventory.prototype._suppressLegacy = function () {
    if (!document.body) return;
    var candidates = document.body.querySelectorAll(
      'div, section, aside, article, ul, ol, [class*="inventory"], [id*="inventory"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      var node = candidates[i];
      if (!node || node === this.el) continue;
      if (node.closest && node.closest('[data-product-warehouse-inventory]')) continue;
      if (node.querySelector && node.querySelector('[data-product-warehouse-inventory]')) continue;
      if (this._isCommerceShell(node)) {
        if (node.hasAttribute && node.hasAttribute('data-pdp-legacy-inventory-suppressed')) {
          node.removeAttribute('data-pdp-legacy-inventory-suppressed');
        }
        continue;
      }
      if (node.hasAttribute && node.hasAttribute('data-pdp-legacy-inventory-suppressed')) continue;
      if (!this._looksLikeLegacy(node)) continue;
      node.setAttribute('data-pdp-legacy-inventory-suppressed', '');
    }
  };

  WarehouseInventory.prototype._looksLikeLegacy = function (node) {
    var text = node.textContent || '';
    if (text.length > 600) return false;
    var hasMarker = false;
    for (var i = 0; i < LEGACY_TEXT_MARKERS.length; i++) {
      if (text.indexOf(LEGACY_TEXT_MARKERS[i]) !== -1) { hasMarker = true; break; }
    }
    if (!hasMarker) return false;
    var className = (node.className && typeof node.className === 'string') ? node.className : '';
    var id = node.id || '';
    var classOrId = (className + ' ' + id).toLowerCase();
    if (classOrId.indexOf('inventoryinfo') !== -1) return true;
    if (classOrId.indexOf('inventory-info') !== -1) return true;
    if (classOrId.indexOf('inventory_info') !== -1) return true;
    if (classOrId.indexOf('hulkapps_inv') !== -1) return true;
    if (classOrId.indexOf('hulkapps-inv') !== -1) return true;
    return false;
  };

  function initAll(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-product-warehouse-inventory]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i]._warehouseInventory) {
        els[i]._warehouseInventory = new WarehouseInventory(els[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
